// extracted by mini-css-extract-plugin
export default {"text_footer":"style_text_footer__3gyjo"};